import React, {Component} from 'react'
import {Formik, Form } from 'formik';
import { MaskedInput } from '../FormGroup';

import * as Yup from "yup";
import Spinner from '../Spinner/Spinner';
import { api } from '../../api/client';
export default class FirstStep extends Component {
    constructor(props) {
        super(props);

        this.onSubmitHandler = this
            .onSubmitHandler
            .bind(this);

        this.state = {
            loading: false,
            serverErrors: []
        };

        this.formRefs = React.createRef();
    }

    onSubmitHandler(values) {

        this
            .props
            .onSubmited(1, values);

    }

    async validateOnServer(userName, accountNumber) {

        this.setState({loading: true});
        try {
            const result = await api.get('users/userRegistrationInfo', {
                params: {
                    userName: userName,
                    accountNumber: accountNumber
                }
            });

           
            this.setState({loading: false});
            if (result.data.IsAccountNumberValid && !result.data.IsAlreadyLinked ) {
                this.setState({serverErrors: []});
                this
                    .props
                    .onGetUserRegistrationInfo(result.data);
                return Promise.resolve(true);
            } else {
                const errorMessages = parseValidationResponse(result); 

                const accountError = result.data.AccountValidationError;
                const accountErrorIdx = errorMessages.findIndex(f => f.indexOf('Account number') > -1);
                if (accountError !== '' && accountErrorIdx > -1) {
                    errorMessages[accountErrorIdx] = `${accountError}`;
                }    

                if (errorMessages.length > 0) {
                    this.setState({serverErrors: errorMessages});
                    return Promise.reject(errorMessages);
                } else {
                    return Promise.resolve(true);
                }
            }
        } catch (e) {
            this.setState({
                loading: false,
                serverErrors: [e.message]
            });
            return Promise.reject(e);
        }
    }

    isValidated() {
        const form = this.formRefs.current;
        const actions = form.getFormikActions();
        const values = form
            .getFormikBag()
            .values;

        return actions
            .validateForm()
            .then(async result => {

                if (Object.keys(result).length === 0) {
                    try {
                        await this.validateOnServer(this.props.login, values.accountNumber);
                        await actions.submitForm();
                        return Promise.resolve(true);
                    } catch (e) {
                        console.log('remote validation failed: ', e);
                        return Promise.reject(); //If reject returns other than undefined or false Stepzilla will give exception!
                    }
                } else {
                    await actions.submitForm();
                    return Promise.reject();
                }
            });

    }

    render() {

        const spinner = this.state.loading
            ? <Spinner/>
            : null;

        const validatationSchema = Yup
            .object()
            .shape({
                accountNumber: Yup
                    .string()
                    .length(8,'Must be exactly 8 digits')      
                    .required('Required')

            });

        const serverErrorDiv = this.state.serverErrors && this.state.serverErrors.length > 0
            ? <div className='errorMessage'>{this
                        .state
                        .serverErrors
                        .map((s, i) => <li key={i}>{s}</li>)
}
                </div>
            : null;

        let initValues = {

            accountNumber: '' // '00120188'
        };

        if (this.props.stepValues) {
            initValues = this.props.stepValues;
        }

        return (
            <div>
                <Formik
                    ref={this.formRefs}
                    initialValues={initValues}
                    validationSchema={validatationSchema}
                    onSubmit={this.onSubmitHandler}>
                    {() => (

                        <Form className="addAccount"> 
                           <MaskedInput
                                   name="accountNumber"
                    label="Account Number"                    
                    mask="99999999"
                    autoFocus
                  />
                          
                            {serverErrorDiv}

                        </Form>
                    )}
                </Formik>

                {spinner}
            </div>
        )
    }
}

function parseValidationResponse(result) {

    const errorMessages = [];
    if (!result.data) {
        errorMessages.push('Something went wrong');
        return errorMessages;
    }

    if (!result.data.IsAccountNumberValid) {
        errorMessages.push('Account number is not valid');
    }

    if (result.data.IsAlreadyLinked ) {
        errorMessages.push('Account number is already linked');
    }
    
    // if (!result.data.IsSsnAssociated) {     errorMessages.push('SSN is not
    // associated'); }
    return errorMessages;
}
